// Shared freshness window for the content caches (home / columns / podcasts).
// While a slice's lastFetched is within this window, hooks skip the silent
// background revalidation entirely — rapid navigation costs zero API calls.
export const CACHE_TTL_MS = 5 * 60 * 1000;

export const isCacheFresh = (lastFetched: number | null): boolean =>
  !!lastFetched && Date.now() - lastFetched < CACHE_TTL_MS;
